import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { OrdersDatagridState } from './types';

export const setShippingPopoverHoveredOrderReducer: CaseReducer<
  OrdersDatagridState,
  PayloadAction<string | null>
> = (state, action) => {
  state.shippingPopover.hoveredOrder = action.payload;
};
